import { InvoicesView } from '@/views/default';
import InvoiceView from '@/components/invoices/InvoiceView.vue';
import InvoicesHome from '@/components/invoices/InvoicesHome.vue';

const invoices = {
  path: 'invoices',
  component: InvoicesView,
  children: [
    {
      path: '',
      name: 'clientInvoices',
      component: InvoicesHome,
    },
    {
      path: ':id',
      name: 'clientInvoice',
      component: InvoiceView,
    },
  ],
};

export default invoices;
